import React, { useState } from 'react';
import axios from 'axios';
import { Row, Column, Button, TextInput, Fieldset, List, Checkbox, Alert } from '@pella/sash-framework';
import EloquaForm from '../../eloqua-form';

import styles from './index.module.scss';
import { eloquaTrackingUrl } from '../../../utilities/constants';

const DistributorApplication = () => {
	const [show, setShow] = useState({ form: true, confirmation: false });

	const onSubmit = (e) => {
		e.preventDefault();

		const data = new FormData(e.target);
		axios
			.post(eloquaTrackingUrl, data)
			.then(() => {
				setShow({ form: false, confirmation: true });
				window.open('https://assess.predictiveindex.com/oi/_new16692?utm_source=pisoftware&utm_content=%2fAssessments%2fOpenInvitation%2f0&utm_medium=46835', '_blank');
			})
			.catch();
	};

	return (
		<>
			{show.form && (
				<EloquaForm
					elqFormName='distributor-form'
					onFormSubmit={(el) => onSubmit(el)}
					className={styles.distributorForm}
				>
					<Row verticalGutters={true}>
						<Column
							xs='12'
							md='6'
						>
							<TextInput
								id='first-name'
								labelText='First Name'
								placeholder='Legal first name'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='given-name'
							/>
						</Column>

						<Column
							xs='12'
							md='6'
						>
							<TextInput
								id='last-name'
								labelText='Last Name'
								placeholder='Legal last name'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='family-name'
							/>
						</Column>

						<Column
							xs='12'
							md='6'
						>
							<TextInput
								type='email'
								id='email'
								labelText='Email'
								placeholder='Email Address'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='email'
							/>
						</Column>

						<Column
							xs='12'
							md='6'
						>
							<TextInput
								id='phone'
								labelText='Phone Number'
								placeholder='Phone Number'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='tel-national'
							/>
						</Column>

						<Column
							xs='12'
							md='8'
						>
							<h3 className='s2-h3__alt'>Preferred Region (NE, SE, Central, NW, SW)</h3>
							<p>Please check regions you would be interested in. Please note, not all regions have availability. Specific markets will not be shared until completion of the approval process.</p>

							<Fieldset
								legendText='Preferred Region'
								theme='redesign'
								className={styles.distributorForm_Fieldset}
								hideLegend={true}
							>
								<List
									bullets='none'
									layout='inline'
									className={styles.distributorForm_List}
								>
									<li>
										<Checkbox
											id='northeast'
											labelText='Northeast'
											group='ne'
											className={styles.distributorForm_Checkbox}
										/>
									</li>

									<li>
										<Checkbox
											id='southeast'
											labelText='Southeast'
											group='se'
										/>
									</li>

									<li>
										<Checkbox
											id='central'
											labelText='Central'
											group='central'
										/>
									</li>

									<li>
										<Checkbox
											id='northwest'
											labelText='Northwest'
											group='nw'
										/>
									</li>

									<li>
										<Checkbox
											id='southwest'
											labelText='Southwest'
											group='sw'
										/>
									</li>
								</List>
							</Fieldset>
						</Column>

						<Column
							xs='12'
							md='6'
						>
							<TextInput
								id='city'
								labelText='Preferred City'
								placeholder='City'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='off'
							/>
						</Column>

						<Column
							xs='12'
							md='6'
						>
							<TextInput
								id='occupation'
								labelText='Current Occupation'
								placeholder='Your Occupation'
								theme='redesign'
								groupClass={styles.distributorForm_Group}
								autoComplete='off'
							/>
						</Column>

						<Column xs='12'>
							<p className={styles.distributorForm_Footnote}>When you click submit, a new window will open to continue the process.</p>

							<Button
								type='submit'
								color='primary-alt'
							>
								Submit
							</Button>
						</Column>
					</Row>
				</EloquaForm>
			)}

			{show.confirmation && (
				<Alert
					type='success'
					className={`${styles.distributorForm_Success} mb-4`}
					hideClose
				>
					Congratulations! You have taken your first step towards becoming a Pella distributor.
				</Alert>
			)}
		</>
	);
};

export default DistributorApplication;
